import { Sizes } from '../../constants/size';
import type { IconProps } from '../../types/icon-props';

export const Search = (props: IconProps) => {
  const { size = 'md', fill = 'var(--grey-1)', stroke = 'var(--grey-1)', ...rest } = props;

  return (
    <svg
      width={Sizes[size]}
      height={Sizes[size]}
      viewBox="0 0 16 16"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <g id="vuesax/outline/search-normal">
        <g id="search-normal">
          <path
            id="Vector"
            d="M7.66536 14.5C3.8987 14.5 0.832031 11.4334 0.832031 7.66671C0.832031 3.90004 3.8987 0.833374 7.66536 0.833374C11.432 0.833374 14.4987 3.90004 14.4987 7.66671C14.4987 11.4334 11.432 14.5 7.66536 14.5ZM7.66536 1.83337C4.44536 1.83337 1.83203 4.45337 1.83203 7.66671C1.83203 10.88 4.44536 13.5 7.66536 13.5C10.8854 13.5 13.4987 10.88 13.4987 7.66671C13.4987 4.45337 10.8854 1.83337 7.66536 1.83337Z"
          />
          <path
            id="Vector_2"
            d="M14.6676 15.1666C14.5409 15.1666 14.4143 15.12 14.3143 15.02L12.9809 13.6866C12.7876 13.4933 12.7876 13.1733 12.9809 12.98C13.1743 12.7866 13.4943 12.7866 13.6876 12.98L15.0209 14.3133C15.2143 14.5066 15.2143 14.8266 15.0209 15.02C14.9209 15.12 14.7943 15.1666 14.6676 15.1666Z"
          />
        </g>
      </g>
    </svg>
  );
};

Search.displayName = 'Search';
